export default {
    captchaEnabled: state => state.captchaEnabled    
}